import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { sellerStaffApi } from '../api/seller-staff.api';
import type { CreateSellerStaffDto, UpdateSellerStaffDto } from '../types';

export const SELLER_STAFF_QUERY_KEY = ['seller-staff'] as const;

export const useSellerStaff = (enabled = true) => {
  return useQuery({
    queryKey: SELLER_STAFF_QUERY_KEY,
    queryFn: () => sellerStaffApi.getAll(),
    enabled,
  });
};

export const useCreateSellerStaff = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateSellerStaffDto) => sellerStaffApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SELLER_STAFF_QUERY_KEY });
      notifications.show({
        title: 'Готово',
        message: 'Сотрудник добавлен. Он сможет войти по этому номеру.',
        color: 'green',
      });
    },
    onError: (error: unknown) => {
      const msg =
        (error as { response?: { data?: { message?: string } } })?.response?.data
          ?.message || 'Не удалось добавить сотрудника';
      notifications.show({ title: 'Ошибка', message: msg, color: 'red' });
    },
  });
};

export const useUpdateSellerStaff = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateSellerStaffDto }) =>
      sellerStaffApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SELLER_STAFF_QUERY_KEY });
      notifications.show({
        title: 'Готово',
        message: 'Доступ обновлён',
        color: 'green',
      });
    },
    onError: (error: unknown) => {
      const msg =
        (error as { response?: { data?: { message?: string } } })?.response?.data
          ?.message || 'Не удалось сохранить';
      notifications.show({ title: 'Ошибка', message: msg, color: 'red' });
    },
  });
};

export const useDeleteSellerStaff = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => sellerStaffApi.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: SELLER_STAFF_QUERY_KEY });
      notifications.show({
        title: 'Готово',
        message: 'Доступ сотрудника отозван',
        color: 'green',
      });
    },
    onError: (error: unknown) => {
      const msg =
        (error as { response?: { data?: { message?: string } } })?.response?.data
          ?.message || 'Не удалось удалить';
      notifications.show({ title: 'Ошибка', message: msg, color: 'red' });
    },
  });
};
